import React, { useEffect, useState, useRef } from "react";
import { useDayPassContext } from "../../stores/DayPassContextProvider";
import Header from "../../components/Header";
import "./style.scss";
import { useStores } from "../../stores";
import notify from "../../components/Notify/notify";
import { useLocation } from "react-router-dom";


function DayPassPayment() {
  let { dataToSend, additionalData } = useDayPassContext();
  const [isChecked, setIsChecked] = useState(true);
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const [accessKey, setAccessKey] = useState("");
  const [updatedData, setUpdatedData] = useState(dataToSend);

  const { bookingStore } = useStores();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");

  const [coupon, setCoupon] = useState("");
  const [validCoupon, setValidCoupon] = useState(false);

  console.log("Main Data from context:", dataToSend);
  console.log("Additional Data from context:", additionalData);

  if (!dataToSend && !additionalData) {
    additionalData = JSON.parse(
      sessionStorage.getItem("day-pass-additional-data")
    );
    dataToSend = JSON.parse(sessionStorage.getItem("day-pass-billing"));
  }

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const imageGallery = JSON.parse(additionalData.image_gallery);
  const firstImage = imageGallery[0];

  const applyCoupon = async (couponName, inventory_id, valid_from, qty) => {
    let params = `inventory_id=${inventory_id}&valid_from=${valid_from}&qty=${qty}&coupon_code=${couponName}`;
    console.log("parms:>>", params);

    await bookingStore.getBookNowDayPass(params, (response) => {
      if (response?.data?.status === 1) {
        console.log("response bill: ", response.data.data);
        dataToSend = response.data.data;

        console.log("data send bill: ", dataToSend);
        setUpdatedData(response.data.data);
        setValidCoupon(true)
        notify("Coupon code applied successfully");
      } else {
        console.error("Error fetching center list");
        notify("Invalid Coupon code", "danger");
        setValidCoupon(false)
      }
    });
  };

  useEffect(() => {
    let url = window.location.pathname;
    let access_key = url.split("/day-pass/book-now/payment/")[1];
    setAccessKey(access_key?.split('&')[0]);
  }, [window.location.pathname]);

  useEffect(() => {
    console.log("Updated Data in UI:", updatedData);
  }, [updatedData]);

  const isFormValid = () => {
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i; // Basic email format regex
  
    return (
      name !== "" &&
      email !== "" &&
      emailPattern.test(email) && // Check if email matches the pattern
      mobile.length === 10
    );
  };
  

  const handlePaymentDayPass = async (couponName,center_id, valid_from, name, email, mobile, qty ) => {
    setLoader(true)
    if (!isFormValid()) {
      setError("Please fill in all the details.");
      return;
    }
    setError("");
    sessionStorage.setItem("acckey", accessKey);

    let params = {
      center_id: center_id,
      valid_from: valid_from,
      qty: qty,
      email: email,
      name: name,
      mobile: mobile,
      access_key: accessKey,
    };

    if (couponName && validCoupon) {
      params.coupon_code = couponName;
    }

    await bookingStore.dayPassBookingPayment(params, (response) => {
      if (response?.data?.status === 1) {
        setTimeout(() => {
          setLoader(false);
        }, 3000);
        window.open(response?.data?.data?.redirectURL, "_self");
      } else {
        console.error("Error fetching center list");
      }
    });
  };

  return (
    <>
      <Header accessKey={accessKey} queryParams={window.location.origin + `/day-pass/${accessKey}`} dayPass={true} />
      <section className="booking-listing-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="payment-detail-box">
                <div className="row">
                  <div className="col-md-6 no-gutters">
                    <div className="payment-content">
                      <img
                        src={firstImage}
                        alt={`Payment Banner 0`}
                        className="payment-banner"
                      />
                      <h3 className="payment-content-heading-day-pass">
                        {additionalData?.name}
                      </h3>
                      <p className="payment-content-text-day-pass">
                        {additionalData?.address}
                      </p>
                      <p className="payment-date-text">
                        {new Date(dataToSend.valid_from).toLocaleDateString('en-US', {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })}{ ' '}
                        <span className="payment-date-text">
                          <span className="pipe-day-pass"></span> { dataToSend?.req_qty} Quantity
                        </span>
                        <span className="payment-date-text">
                          <span className="pipe-day-pass"></span> { additionalData?.oppening_time} {'-'} {additionalData?.closing_time}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="billing-detail-box-day-pass">
                      <p className="billing-detail-heading-day-pass">Billing Details</p>

                      {/* Apply coupon code here */}
                      <div className="coupon-code-box-day-pass">
                        <div className="row coupon-full-box-day-pass">
                          <div className="col-md-12 mobileview-dnone">
                            <div className="coupon-input-container">
                              <img
                                src={require("../../assets/images/badge.png")}
                                alt="Location"
                                className="coupon-icon-day-pass"
                              />
                              <input
                                type="text"
                                className="form-control coupon-field-day-pass"
                                value={coupon}
                                onChange={(e) => setCoupon(e.target.value)}
                                placeholder="Apply Coupon Code"
                              />
                              <button
                                type="button"
                                className={`coupon-btn-day-pass ${coupon ? "active" : ""}`}
                                onClick={() => {
                                  applyCoupon(
                                    coupon,
                                    additionalData?.inventory_id,
                                    dataToSend?.valid_from,
                                    dataToSend?.req_qty
                                  );
                                }}
                              >
                                Apply Coupon
                              </button>
                            </div>
                          </div>
                          <div className="col-md-12 mobileview-dblock">
                            <div className="coupon-input-container-day-pass">
                              <img
                                src={require("../../assets/images/badge.png")}
                                alt="Location"
                                className="coupon-icon-day-pass"
                              />
                              <input
                                type="text"
                                className="form-control coupon-field-day-pass text-center"
                                value={coupon}
                                onChange={(e) => setCoupon(e.target.value)}
                                placeholder="Apply Coupon Code"
                                onClick={() => {
                                    // Handle coupon submission here
                                    applyCoupon(
                                      coupon,
                                      additionalData?.inventory_id,
                                      dataToSend?.valid_from,
                                      dataToSend?.req_qty
                                    );
                                  }}
                              />
                              {/* <button
                                type="button"
                                className="coupon-btn-day-pass"
                                onClick={() => {
                                  // Handle coupon submission here
                                  applyCoupon(
                                    coupon,
                                    additionalData?.inventory_id,
                                    dataToSend?.valid_from,
                                    dataToSend?.req_qty
                                  );
                                }}
                              >
                                Apply Coupon
                              </button> */}
                            </div>
                          </div>

                          {validCoupon && (
                              <div className="col-md-12">
                                <div class="list-box-day-pass rcoupon">
                                  <div class="list-box-inner">
                                    <p>
                                      <span>
                                        <i class="fa fa-tag"></i>
                                      </span>
                                      {coupon} {}
                                      <span className="cc-applied">
                                        applied
                                      </span>
                                    </p>
                                  </div>
                                  <div class="list-box-inner">
                                    <a
                                      className="cremove-btn"
                                      onClick={() => {
                                        setCoupon('');
                                        setValidCoupon(false);
                                        notify("Coupon removed successfully", "danger");

                                      }}
                                    >
                                      Remove
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}

                        </div>
                      </div>

                      {/* End of coupon code section */}

                      {/* Rest of the billing details */}
                      <div className="total-price-inner-day-pass">
                        <p className="total-text">Sub Total</p>
                        <p className="text-price">
                          Rs{" "}
                          {updatedData?.base_amount ?? dataToSend?.base_amount}
                        </p>
                      </div>
                      <div className="total-price-inner-day-pass">
                        <p className="total-text">SGST(9%)</p>
                        <p className="text-price">
                          Rs{" "}
                          {updatedData?.tax_break_up[0].value ??
                            dataToSend?.tax_break_up[0].value}
                        </p>
                      </div>
                      <div className="total-price-inner-day-pass">
                        <p className="total-text">CGST(9%)</p>
                        <p className="text-price">
                          Rs{" "}
                          {updatedData?.tax_break_up[1].value ??
                            dataToSend?.tax_break_up[1].value}
                        </p>
                      </div>
                      <div className="total-price-inner-day-pass">
                        <p className="total-text">IGST(0%)</p>
                        <p className="text-price">
                          Rs{" "}
                          {updatedData?.tax_break_up[2].value ??
                            dataToSend?.tax_break_up[2].value}
                        </p>
                      </div>
                      <div className="total-price-inner-day-pass">
                        <p className="total-text">Discount</p>
                        <p className="text-price">
                          Rs {updatedData?.discount ?? dataToSend?.discount}
                        </p>
                      </div>
                      <div className="total-price-inner-day-pass">
                        <p className="total-text-big">Sub Total</p>
                        <p className="text-price-big total-text-big">
                          Rs{" "}
                          {updatedData?.total_price ?? dataToSend?.total_price}{" "}
                          /-
                        </p>
                      </div>

                      <div className="total-price-inner-day-pass grand-total">
                        <p className="total-text-gbig">Grand Total</p>
                        <p className="text-price-gbig">
                          Rs{" "}
                          {updatedData?.total_price ?? dataToSend?.total_price}{" "}
                          /-
                        </p>
                      </div>

                      {/* Here i want these checkbox  */}

                      <div className="checkbox-section-day-pass">
                        <div className="checkbox-day-pass">
                          <input
                            type="checkbox"
                            className="input-assumpte-day-pass"
                            id="accept-term"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                          <label htmlFor="accept-term"></label>
                          <div className="checkbox-text-day-pass">
                            I have read and agreed to terms and conditions
                            available on www.awfis.com
                          </div>
                        </div>
                      </div>

                      {/* Payment button */}
                      <div className="payment-btn-box-day-pass text-center">
                        <button
                          type="button"
                          className={`pay-btn-day-pass ${isChecked ? '' : 'disabledBookNow'}`}
                          data-toggle="modal"
                          data-target="#proceedModalDayPass"
                          disabled={!isChecked}
                        >
                          BOOK NOW
                        </button>
                      </div>

                      {/* Notes section */}
                      <div className="notes-box-day-pass">
                        <p className="notes-text-day-pass">
                          NOTE. These details cannot be updated/changed once
                          booking is completed
                        </p>
                        <p className="notes-text-day">
                          ** Hi, please note that the booking will hold for 15
                          minutes till payment is done. Post that an email will
                          be sent for booking confirmation!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="modal fade" id="proceedModalDayPass">
        <div className="modal-dialog">
          <div className="modal-content content-popup">
            {/* <!-- Modal Header --> */}
            <div className="modal-header popup-day-pass">
              <button
                type="button"
                className="close close-day-pass"
                data-dismiss="modal"
              >
                &times;
              </button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="modal-body popup-day-pass">
              <h3 className="popup-day-pass-heading">
              Log in to continue{" "}
              </h3>
              <form className="popup-day-pass-form">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control popup-day-pass-field"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setError("");
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control popup-day-pass-field"
                    placeholder="Email Id"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError("");
                    }}
                  />
                </div>
                <div className="form-group">
                <input
                type="tel"
                className={`form-control popup-day-pass-field ${mobile.length !== 10 ? "invalid-input" : ""}`}
                placeholder="Mobile no."
                value={mobile}
                maxLength={10}
                pattern="[0-9]{10}"
                onChange={(e) => {
                    setMobile(e.target.value);
                    setError("");
                }}
                />

                </div>
                <button
                  type="submit"
                  className={`popup-day-pass-btn ${!isFormValid() ? "disabled-button" : ""}`}
                  data-dismiss="modal"
                  disabled={!isFormValid()}
                  onClick={() => {
                    handlePaymentDayPass(
                      coupon,
                      additionalData?.id,
                      dataToSend?.valid_from,
                      name,
                      email,
                      mobile,
                      dataToSend?.req_qty
                    );
                  }}
                >
                  Proceed to payment
                </button>
              </form>
            </div>

            {/* <!-- Modal footer --> */}
            {loader && <div className="loader"></div>}
          </div>
        </div>
      </div>
    </>
  );
}

export default DayPassPayment;
